export const SET_FILTER_REGISTRATION_FROM = "SET_FILTER_REGISTRATION_FROM";
export const RESET_FILTER_REGISTRATION_FROM = "RESET_FILTER_REGISTRATION_FROM";

export const SET_FILTER_REGISTRATION_TO = "SET_FILTER_REGISTRATION_TO";
export const RESET_FILTER_REGISTRATION_TO = "RESET_FILTER_REGISTRATION_TO";

export const SET_FILTER_ORGANIZATION_TYPE = "SET_FILTER_ORGANIZATION_TYPE";
export const RESET_FILTER_ORGANIZATION_TYPE = "RESET_FILTER_ORGANIZATION_TYPE";

export const SET_FILTER_UNDER_LIQUIDATION = "SET_FILTER_UNDER_LIQUIDATION";
export const RESET_FILTER_UNDER_LIQUIDATION = "RESET_FILTER_UNDER_LIQUIDATION";

export const SET_FILTER_IS_BANKRUPT = "SET_FILTER_IS_BANKRUPT";
export const RESET_FILTER_IS_BANKRUPT = "RESET_FILTER_IS_BANKRUPT";

export const SET_FILTER_IS_VAT_REGISTERED = "SET_FILTER_IS_VAT_REGISTERED";
export const RESET_FILTER_IS_VAT_REGISTERED = "RESET_FILTER_IS_VAT_REGISTERED";

export const SET_FILTER_IN_BUSINESS_REGISTER =
  "SET_FILTER_IN_BUSINESS_REGISTER";
export const RESET_FILTER_IN_BUSINESS_REGISTER =
  "RESET_FILTER_IN_BUSINESS_REGISTER";

export const SET_FILTER_IN_FOUNDATION_REGISTER =
  "SET_FILTER_IN_FOUNDATION_REGISTER";
export const RESET_FILTER_IN_FOUNDATION_REGISTER =
  "RESET_FILTER_IN_FOUNDATION_REGISTER";

export const SET_FILTER_EMPLOYEES_FROM = "SET_FILTER_EMPLOYEES_FROM";
export const RESET_FILTER_EMPLOYEES_FROM = "RESET_FILTER_EMPLOYEES_FROM";

export const SET_FILTER_EMPLOYEES_TO = "SET_FILTER_EMPLOYEES_TO";
export const RESET_FILTER_EMPLOYEES_TO = "RESET_FILTER_EMPLOYEES_TO";

export const APPEND_LOCATION_FILTER = "APPEND_LOCATION_FILTER";
export const RESET_APPEND_LOCATION_FILTER = "RESET_APPEND_LOCATION_FILTER";

export const REMOVE_LOCATION_FILTER = "REMOVE_LOCATION_FILTER";
export const RESET_REMOVE_LOCATION_FILTER = "RESET_REMOVE_LOCATION_FILTER";

export const REQUEST_LIST_SIZE = "REQUEST_LIST_SIZE";
export const SET_LIST_SIZE = "SET_LIST_SIZE";
export const REVOKE_LIST_SIZE = "REVOKE_LIST_SIZE";
export const RESET_LIST_SIZE = "RESET_LIST_SIZE";

export const APPEND_INDUSTRY_CODE_FILTER = "APPEND_INDUSTRY_CODE_FILTER";
export const RESET_APPEND_INDUSTRY_CODE_FILTER =
  "RESET_APPEND_INDUSTRY_CODE_FILTER";

export const REMOVE_INDUSTRY_CODE_FILTER = "REMOVE_INDUSTRY_CODE_FILTER";
export const RESET_REMOVE_INDUSTRY_CODE_FILTER =
  "RESET_REMOVE_INDUSTRY_CODE_FILTER";

export const REQUEST_ADD_NEW_LIST = "REQUEST_ADD_NEW_LIST";
export const REVOKE_ADD_NEW_LIST = "REVOKE_ADD_NEW_LIST";
export const RESET_ADD_NEW_LIST = "RESET_ADD_NEW_LIST";
export const GRANT_ADD_NEW_LIST = "GRANT_ADD_NEW_LIST";

export const SET_API_URL = "SET_API_URL";
export const RESET_API_URL = "RESET_API_URL";

export const RESET_LIST_INPUT = "RESET_LIST_INPUT";
